export const VenezuelaBanks = [
  'Banco Central de Venezuela',
  'Banco de Venezuela, S.A. Banco Universal',
  'Banco Venezolano de Crédito, S.A. Banco Universal',
  'Banco Mercantil C.A., Banco Universal',
  'Banco Provincial, S.A. Banco Universal',
  'Banco del Caribe C.A., Banco Universal',
  'Banco Exterior C.A., Banco Universal',
  'Banco Caroní C.A., Banco Universal',
  'Banesco Banco Universal, C.A.',
  'Banco Sofitasa Banco Universal, C.A .',
  'Banco Plaza, Banco universal',
  'Banco de la Gente Emprendedora C.A.',
  'Banco Fondo Común, C.A Banco Universal',
  '100% Banco, Banco Comercial, C.A',
  'DelSur, Banco Universal C.A.',
  'Banco del Tesoro C.A., Banco Universal',
  'Banco Agrícola de Venezuela C.A., Banco Universal',
  'Bancrecer S.A., Banco Microfinanciero',
  'Mi Banco, Banco Microfinanciero, C.A.',
  'Banco Activo C.A., Banco Universal',
  'Bancamiga Banco Universal, C.A.',
  'Banco Internacional de Desarrollo C.A., Banco Universal',
  'Banplus Banco Universal, C.A.',
  'Banco Bicentenario del Pueblo, Banco Universal C.A.',
  'Banco de la Fuerza Armada Nacional Bolivariana, B.U.',
  'Banco Nacional de Crédito C.A., Banco Universal',
  'Instituto Municipal de Crédito Popular ',
] as const;

export type VenezuelaBanks = typeof VenezuelaBanks[keyof typeof VenezuelaBanks];
